module.exports = __webpack_public_path__ + "img/menu-lines-white.f4314dd7.svg";